import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { CheckoutErrorBanner } from '@components/ProductOffers/modals/ShoppingCartDrawer/CheckoutErrorBanner';
import { fmt } from '@components/ProductOffers/modals/ShoppingCartDrawer/PricingSummary/PricingSummary';
import LoadingButton from '@shared/components/buttons/LoadingButton/LoadingButton';

interface CartDrawerFooterProps {
  hasItems: boolean;
  monthlyTotal: number;
  oneTimeTotal: number;
  isCartLoading: boolean;
  isCheckoutPending?: boolean;
  checkoutError?: boolean;
  onCheckout: () => void;
  onOpenIntakeForm: () => void;
}

export const CartDrawerFooter = ({
  hasItems,
  monthlyTotal,
  oneTimeTotal,
  isCartLoading,
  isCheckoutPending,
  checkoutError,
  onCheckout,
  onOpenIntakeForm,
}: CartDrawerFooterProps) => {
  const theme = useTheme();

  return (
    <Paper variant="cartDrawerFooter">
      {checkoutError && <CheckoutErrorBanner onOpenIntakeForm={onOpenIntakeForm} rounded />}

      {hasItems && (
        <>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="cartTotalLabel">Total Recurring Monthly Charges</Typography>
            <Typography variant="cartTotalLabel">{fmt(monthlyTotal)}</Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="cartTotalLabel">Total One Time Charges</Typography>
            <Typography variant="cartTotalLabel">{fmt(oneTimeTotal)}</Typography>
          </Stack>
          <Typography variant="body.sm" color={theme.novus.borderBlack} mb="5px">
            **Your first bill may be slightly higher due to a small prorated charge before your first billing cycle
            begins.
          </Typography>
        </>
      )}

      <LoadingButton
        variant="checkoutDrawer"
        disabled={!hasItems || isCartLoading}
        loading={isCheckoutPending}
        onClick={onCheckout}
      >
        Checkout
      </LoadingButton>
    </Paper>
  );
};
